// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-4f541700] .el-dialog {\n  max-width: 600px;\n}\n[data-v-4f541700] .el-dialog__body {\n  margin-bottom: -20px;\n}\n[data-v-4f541700] .dialog-footer {\n  display: flex;\n  justify-content: space-between;\n}\n.table-wrapper-alt[data-v-4f541700] {\n  margin-right: -5px;\n  margin-left: -5px;\n}\ntd[data-v-4f541700] {\n  padding: 5px;\n}", ""]);
// Exports
module.exports = exports;
